import { CheckCircle2 } from "lucide-react";
import { TrustindexWidget } from "@/components/TrustindexWidget";

const usps = [
"Persoonlijk contact",
"Vaste prijzen",
"Alles onder één dak"];

export function TopBar() {
  return (
    <div className="hidden lg:block bg-background border-b border-border text-xs text-muted-foreground">
      <div className="container-wide">
        <div className="flex items-center justify-between h-9">
          {/* Left: USPs */}
          <div className="flex items-center gap-5">
            {usps.map((usp) =>
            <span key={usp} className="inline-flex items-center gap-1.5">
                <CheckCircle2 className="h-3 w-3 text-primary shrink-0" />
                {usp}
              </span>
            )}
          </div>

          {/* Right: Rating + Contact */}
          <div className="flex items-center divide-x divide-border">
            {/* Trustindex Widget */}
            <div className="px-0">
              <TrustindexWidget loaderId="135804567d2e621e47163553dab" eager className="inline-flex items-center" />
            </div>

            {/* Email */}
            





            
          </div>
        </div>
      </div>
    </div>);

}